module.exports = __webpack_public_path__ + "img/service-icon3.bbd49924.png";